import { __awaiter } from "tslib";
import { Cache } from 'three';
import { promiseAllObject, mapObject } from '../utils/object-tools';
const textureAssets = {
    smoke: '/assets/smoke.png',
};
export class Assets {
    static load() {
        return __awaiter(this, void 0, void 0, function* () {
            Cache.enabled = true;
            yield Promise.all([
                Assets.loadTextures(),
                Assets.loadModels(),
            ]);
        });
    }
    static loadTextures() {
        return __awaiter(this, void 0, void 0, function* () {
            this.textures = yield promiseAllObject(mapObject(textureAssets, Assets.loadTexture));
        });
    }
    static loadModels() {
        return __awaiter(this, void 0, void 0, function* () {
            // Load all relevant assets simultaneously.
            const [goal, treadBot, objects] = yield Promise.all([
                Assets.loadGltf('/assets/goal.glb'),
                Assets.loadGltf('/assets/chefbot.glb'),
                Assets.loadGltf('/assets/objects.glb'),
            ]);
            // Unpack assets.
            Assets.goal = goal.scene;
            Assets.objects = Assets.extractAllObjects(objects.scene);
            Assets.treadBot = Assets.extractObject(treadBot.scene, 'Chefbot_Armature');
            Assets.treadBotAnimations = treadBot.animations.reduce((set, next) => (Object.assign(Object.assign({}, set), { [next.name]: next })), {});
        });
    }
    static loadTexture(path) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const loader = new window.THREE.TextureLoader();
                loader.load(path, resolve, undefined, reject);
            });
        });
    }
    static loadGltf(path) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                new window.THREE.GLTFLoader().load(path, resolve, undefined, reject);
            });
        });
    }
    static extractAllObjects(scene) {
        return scene.children.reduce((acc, child) => {
            child.position.set(0, 0, 0);
            acc[child.name] = child;
            return acc;
        }, {});
    }
    static extractObject(scene, name) {
        const object = scene.getObjectByName(name);
        if (!object) {
            throw new Error('Object not found: ' + name);
        }
        return object;
    }
}
